import React, { createContext, useContext, useMemo } from 'react';
import { useAuth } from './AuthContext';
import { getCurrencyFromCountry, getCurrencySymbol, formatCurrency, formatWithSymbol } from '../utils/currency';

const CurrencyContext = createContext(null);

export const useCurrency = () => {
  const context = useContext(CurrencyContext);
  if (!context) {
    throw new Error('useCurrency must be used within CurrencyProvider');
  }
  return context;
};

export const CurrencyProvider = ({ children }) => {
  const { user } = useAuth();

  const currencyInfo = useMemo(() => {
    // Get currency directly from user profile (defaults to USD)
    const currencyCode = user?.currency || 'USD';
    
    // Get currency symbol
    const symbol = getCurrencySymbol(currencyCode);
    
    // Helper function to format currency
    const format = (amount, options = {}) => {
      return formatCurrency(amount, currencyCode, options);
    };
    
    // Helper function to format with symbol only
    const formatSymbol = (amount) => {
      return formatWithSymbol(amount, currencyCode);
    };
    
    return {
      currencyCode,
      symbol,
      format,
      formatSymbol,
    };
  }, [user]);

  return (
    <CurrencyContext.Provider value={currencyInfo}>
      {children}
    </CurrencyContext.Provider>
  );
};
